module.exports = __webpack_public_path__ + "a4db52b60f8bfef2e3a177ca85e44d5b.svg";